import styled from 'styled-components';

export const FooterWrapper = styled.footer`
    background-color: #1a1a1a;
		position: relative;
`;

export const FooterIcon = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 3px;
    background-color: white;
`;

export const FooterLabel = styled.p(
	({ theme: { down, breakpoints } }) => `
  
        ${down(breakpoints.md)} {
            font-size: 14px;
        }
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 900;
        color: white;
        padding: 16px 0;
    
      `
);

export const FooterColWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
        ${down(breakpoints.tb)} {
            width:30%;
            margin-bottom: 30px;
        }
        ${down(breakpoints.md)} {
            width:50%;
            margin-bottom: 30px;
        }
    
      `
);

export const FooterItems = styled.li(
	({ theme: { down, breakpoints } }) => `
  
        ${down(breakpoints.md)} {
            font-size: 12px;
        }
        font-size: 16px;
        color: white;
        margin-bottom: 8px;
        >a{
            color: #fff;
        }
    
      `
);

export const DummyDownload = styled.div`
    width: 128px;
    height: 43px;
    border-radius: 3px;
    background-color: #d8d8d8;
    margin-bottom: 8px;
`;
